<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <ListIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('category.list') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0"></div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <CategoryListTable />
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import CategoryListTable from '@/components/category/CategoryListTable'

export default defineComponent({
  components: {
    CategoryListTable
  },
  setup() {
    return {}
  }
})
</script>
